import { PARITY_SEED } from "./config";

let state = PARITY_SEED >>> 0;

export function resetParityRng(seed = PARITY_SEED) {
  state = seed >>> 0;
}

/** @deprecated No-op — scorecard always uses Mulberry32(PARITY_SEED). */
export function disableParityRng() {}

export function scorecardRandom() {
  let t = (state += 0x6d2b79f5);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}
